export default __webpack_public_path__ + "static/media/Blank.9981357e.svg";